module.exports = __webpack_public_path__ + "static/img/24.24f1cfc0.png";